import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface SortableHeaderProps {
  attribute: string
  filtersForm: Form
}

const SortableHeader = observer(
  ({ attribute, filtersForm, children }: React.PropsWithChildren<SortableHeaderProps>) => {
    const sortDirection = filtersForm.get('sortDirection')
    const sortAttribute = filtersForm.get('sortAttribute')

    return (
      <Table.SortableHeadCell
        onSort={(attr, direction) => {
          sortDirection.set(direction)
          sortAttribute.set(attr)
        }}
        attribute={attribute}
        sortAttribute={sortAttribute.value}
        sortDirection={sortDirection.value}
      >
        {children}
      </Table.SortableHeadCell>
    )
  }
)
interface Props {
  filtersForm: Form
}

const Header = ({ filtersForm }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        <Table.HeadCell />
        <SortableHeader filtersForm={filtersForm} attribute="title">
          {i18n.t('custom_reports.dashboards.table.name')}
        </SortableHeader>
        <SortableHeader filtersForm={filtersForm} attribute="author">
          {i18n.t('custom_reports.dashboards.table.created_by')}
        </SortableHeader>
        <SortableHeader filtersForm={filtersForm} attribute="created_at">
          {i18n.t('custom_reports.dashboards.table.created_at')}
        </SortableHeader>
        <SortableHeader filtersForm={filtersForm} attribute="updated_at">
          {i18n.t('custom_reports.dashboards.table.updated_at')}
        </SortableHeader>
        <Table.HeadCell />
      </Table.Row>
    </Table.Head>
  )
}

export default observer(Header)
